import { Controller } from '@hotwired/stimulus'
import { Modal } from 'bootstrap'

// This controller handles modals in conjunction with the
// modal component provided by Bootstrap 5:
// https://getbootstrap.com/docs/5.0/components/modal/
export default class extends Controller {
  static targets = ['container', 'modal']

  connect() {
    this.formInvokedParam = "new_form_invoked"

    if (this.hasModalTarget) {
      // Prevent param from persisting on refresh
      this.modalTarget.addEventListener('hidden.bs.modal', () => {
        var url = new URL(window.location)

        if (url.searchParams.has(this.formInvokedParam, "1")) {
          url.searchParams.delete(this.formInvokedParam)
          window.history.replaceState({}, "", url.toString());
        }
      })
    }

    // Automatically open modal
    this.invoked = this.containerTarget.getAttribute('data-modals-invoked')
    if (this.invoked) {
      this.showModal()
    }
  }

  showModal() {
    this.bsModal = Modal.getOrCreateInstance(this.modalTarget)
    this.bsModal.show()
  }
}
